import React from 'react';
import './RouteAccordion.css';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fab,
    Grid,
    Unstable_Grid2 as Grid2,
    Typography
} from "@mui/material";
import { ActionPanel } from "../../../components/FormZero/ActionPanel/ActionPanel";
import { Subject } from "rxjs";
import { Button } from "../../../components/FormZero/Button/Button";
import { FormPane } from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import axios from "axios";
import { Paper } from "@mui/material";
import { DataGrid, GridCallbackDetails, GridCellEditCommitParams, GridValidRowModel, MuiBaseEvent, MuiEvent } from '@mui/x-data-grid';
import { IApplication } from "../../../interfaces/IApplication";
import { setApplicationValues, setPageTitle } from "../../../slices/applicationSlice";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import { useState, useEffect } from "react";
import { Anchor } from 'react-bootstrap';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import SupportIcon from '@mui/icons-material/ContactSupport';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import AddIcon from '@mui/icons-material/Add';
import ActionMenu from '../../../components/ActionMenu';
import ActionButton from '../../../components/ActionButton';
import AddRouteModalControl from './AddRouteModalControl';
import { CustomDataGrid } from '../../../components/StripedDataGrid';
import AddCustomerLocationModalControl from './AddCustomerLocationModalControl';
import { IRoute } from '../../../interfaces/Logistics/Route';
import { ICustomerLocation } from '../../../interfaces/Logistics/CustomerLocation';

type Anchor = 'top' | 'left' | 'bottom' | 'right';


function DeleteLocationConfirmDialog(props: { setShow: any; onYes: any; }) {
    const { setShow, onYes } = props;

    return (
        <Dialog
            open={true}
            onClose={() => setShow(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                Are you sure?
            </DialogTitle>
            <DialogContent style={{ width: '300px' }}>
                Are you sure you would like to delete this location?
            </DialogContent>
            <DialogActions style={{ display: 'flex' }}>
                <Button onClick={() => setShow(false)} autoFocus text={"No"} fullWidth={true} />
                <Button onClick={() => onYes()} autoFocus color={"error"} text={"Yes"} fullWidth={true} />
            </DialogActions>
        </Dialog>
    );
}

function DeleteLocationCell(props: { cellValues: any; loadRoutes: any; }) {
    const { cellValues, loadRoutes } = props;
    const [show, setShow] = React.useState(false);
    const requestRemoveLocation = async (id: any) => {
        try {
            await axios.delete(`logistic/locations/${id}`);
            await loadRoutes();
        }
        catch (e) {
            console.log(e);
        }
    }
    return (<>
        <Button
            variant="contained" color="primary" fullWidth={true}
            onClick={(event: { stopPropagation: () => void; }) => {
                console.log(`Clicked`)
                console.log(cellValues);
                event.stopPropagation();
                // endpoint is logistic location
                setShow(true);
            }}
        ><Typography variant="h6" color="#FFF" textAlign="left" fontWeight={600}>Remove</Typography></Button>
        
    </>);
}

export function RouteAccordion(props: any) {

    const dispatch = useAppDispatch();

    useEffect(() => {

        let appState: IApplication = {
            pageTitle: "Route Manager",
            backgroundPath: "../assets/images/spaceallocationnbg.jpg"
        }
        dispatch(setPageTitle(appState));
    }, []);

    const { } = props;

    const loadRoutes = async function () {
        try {
            // const result
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Routes`);
            setRoutes(response.data);
            // setExpanded(expanded);
        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };

    const onRowCommit = async (newRow: GridValidRowModel, oldRow: GridValidRowModel) => {
        console.log("ROW EDIT NEW", newRow);
        console.log("ROW EDIT OLD", oldRow);
        const resp = await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/CustomerLocations/${newRow.id}`, newRow).then((resp) => {
            if (resp.status === 204) {

            } else {
                console.log(resp);
            }
        });

        return newRow;
    }

    const stopColumns = [
        { field: 'id', headerName: 'ID', width: 150, editable: false },
        { field: 'customerName', headerName: 'Customer Name', width: 200, editable: true },
        { field: 'city', headerName: 'City', width: 200, editable: true },
        { field: 'state', headerName: 'State', width: 200, editable: true },
        {
            field: "Remove", headerName: '', width: 100,
            renderCell: (cellValues: any) => {
                return (<DeleteLocationCell cellValues={cellValues} loadRoutes={loadRoutes} />);
            }
        },
    ];

    const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [routes, setRoutes] = React.useState<any>([]);


    const updateRouteSubject = new Subject();
    const [updateRouteData, setUpdateRouteData] = React.useState({});
    updateRouteSubject.subscribe((v: any) => setUpdateRouteData(v));

    const updateRoute = async function (route_id: boolean) {
        try {
            // const result

            let nd: any = { ...updateRouteData };
            delete nd.locations;
            delete nd.loads;

            const response = await axios.put(`logistic/routes/${route_id}`, nd);
            await loadRoutes();
        } catch (e) {
            console.log(e);
        }
    };
    const updateRouteStructure = [
        { key: "name", size: { default: 3 }, type: "text", label: "Name" },
        { key: "description", size: { default: 6 }, type: "text", label: "Description" },
        {
            size: {
                default: 3
            },
            type: "button",
            label: "Update",
            clickHandler: () => {
                updateRoute(expanded).then()
            }
        },
    ];

    React.useEffect(() => {
        setIsLoading(true);
        loadRoutes().then(() => {
            setIsLoading(false);
        })
    }, []);

    // Accordion Controls

    const handleChange = (panel: boolean | ((prevState: boolean) => boolean)) => (event: any, isExpanded: any) => {
        setExpanded(isExpanded ? panel : false);
    };

    // const panel = (<PanelView routes={routes} openRoute={expanded} loadRoutes={loadRoutes} />);

    //Toggle drawer

    const toggleDrawer =
        (anchor: Anchor, open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    ((event as React.KeyboardEvent).key === 'Tab' ||
                        (event as React.KeyboardEvent).key === 'Shift')
                ) {
                    return;
                }

                setState({ ...state, [anchor]: open });
            };

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [helpOpen, setHelpOpen] = React.useState(false);

    const handleClickHelpOpen = () => {
        setHelpOpen(true);
    };

    const handleHelpClose = () => {
        setHelpOpen(false);
    };

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    let actionMenuButtons = [
        <ActionButton action={(e) => setShowRouteModal(true)} buttonLabel='Add Route'></ActionButton>,
        <ActionButton action={(e) => setShowCustomerModal(true)} buttonLabel='Add Customer Location'></ActionButton>,
    ]

    const [showRouteModal, setShowRouteModal] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [currentRoute, setCurrentRoute] = useState<IRoute>();

    return (
        <>
            <ActionMenu buttons={actionMenuButtons}></ActionMenu>
            <AddRouteModalControl loadRoutes={loadRoutes} showDialog={showRouteModal} setShowDialog={setShowRouteModal}></AddRouteModalControl>
            <AddCustomerLocationModalControl routes={routes} loadRoutes={loadRoutes} openRoute={currentRoute!} showDialog={showCustomerModal} setShowDialog={setShowCustomerModal} ></AddCustomerLocationModalControl>
            <div className="RouteAccordion">
                <div style={{ padding: "1rem", height: 'calc( 100vh - 96px)', overflow: 'scroll' }}>
                    {routes.map((route: any, index: number) => {
                        return (
                            <Accordion expanded={expanded === route.id} onChange={() => { setExpanded(expanded === route.id ? undefined : route.id); setCurrentRoute(route) }} key={route.id}>
                                <AccordionSummary
                                    style={{
                                        backgroundColor: (route.id === expanded) ? '#83AE0D' : (index % 2 === 1) ? '#EBEBEB' : 'white',
                                        color: (route.id === expanded) ? 'white' : 'black'
                                    }}
                                >
                                    <Typography style={{ fontWeight: 800 }}>
                                        {`${route.name} (${route.customerLocations.length} stops)`}
                                    </Typography>
                                    <Typography
                                        style={{ color: 'text.secondary' }}>{route['routeDescription']}</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ height: "500px", backgroundColor: '#DDDDDD' }}>
                                    {route.id === expanded && (
                                        <div style={{ display: 'flex', flexDirection: "column", width: '100%', gap: '0.5rem' }}>
                                            <Grid container xs={12}>
                                                <Grid xs={12}>
                                                    <Paper style={{ padding: '1rem' }} elevation={1}>
                                                        <FormPane formStructure={updateRouteStructure}
                                                            formSubject={updateRouteSubject} initialFormData={route} />
                                                    </Paper>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <CustomDataGrid
                                                        rows={route.customerLocations}
                                                        editMode='row'
                                                        columns={stopColumns}
                                                        pageSize={10}
                                                        rowsPerPageOptions={[10]}
                                                        disableSelectionOnClick={true}
                                                        processRowUpdate={(newRow, oldRow) => onRowCommit(newRow, oldRow)}
                                                        onProcessRowUpdateError={(error) => console.log(error)}
                                                        experimentalFeatures={{ newEditingApi: true }}
                                                        autoHeight
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                    {(!isLoading && routes.length === 0) && (
                        <Typography style={{ fontWeight: 800, textAlign: "center" }}>
                            There are no created routes. Please add a route.
                        </Typography>
                    )}
                    {(isLoading) && (
                        <Typography style={{ fontWeight: 800, textAlign: "center" }}>
                            Loading Routes. Please wait.
                        </Typography>
                    )}
                </div>
                {/* <ActionPanel Body={panel}/> */}
            </div>
        </>
    )
}
